import { Locales } from '@shared/enums/Locales';
import { EventVisibility } from '@shared/enums/EventVisibility.js';

export function cloneEventProps(event, name, categoryParentId) {
	// Event title is multi-language, get all name locales from the source event, fallback to window locale
	let nameLocales = Object.keys(event.nameTranslations).filter(l => event.nameTranslations[l]);
	if (nameLocales.length === 0) {
		nameLocales = [window.locale ?? Locales.DE];
	}
	const eventName = {};
	nameLocales.forEach(locale => eventName[locale] = name);

	return {
		name:             eventName,
		description:      null,
		visibility:       EventVisibility.HIDDEN,
		categoryParentId: categoryParentId,
		sportId:          event.sport.id,
		locationId:       event.location?.id ?? event.venue?.location?.id ?? null,
		participants:     event.participants?.map(participant => {
			return {
				order:            participant.order,
				type:             participant.type,
				context:          participant.context,
				participatableId: participant.participatable.id,
			};
		}) ?? [],
		geoblocking:             event.geoblocking,
		audioLanguages:          event.audioLanguages,
		arenaCroppingEnabled:    event.arenaCroppingEnabled,
		arenaDownloadEnabled:    event.arenaDownloadEnabled,
		productPlacementEnabled: event.productPlacementEnabled,
		sourceEventId:           event.id,
	};
}
